import { memo } from "react";
import { LoaderCircleIcon, WifiOffIcon } from "lucide-react";

export type RuntimeGroupStatus = "offline" | "sync_pending";

export function getRuntimeGroupStatusLabel(status: RuntimeGroupStatus): string {
  return status === "offline" ? "Offline" : "Sync pending";
}

interface RuntimeGroupStatusIndicatorProps {
  readonly status: RuntimeGroupStatus;
}

export const RuntimeGroupStatusIndicator = memo(function RuntimeGroupStatusIndicator({
  status,
}: RuntimeGroupStatusIndicatorProps) {
  const label = getRuntimeGroupStatusLabel(status);

  return (
    <span
      aria-label={`Runtime ${label.toLowerCase()}`}
      className="inline-flex shrink-0 items-center gap-1 text-[9px] font-medium tracking-normal text-muted-foreground/60 normal-case"
    >
      {status === "offline" ? (
        <WifiOffIcon className="size-2.5 shrink-0" aria-hidden="true" />
      ) : (
        <LoaderCircleIcon className="size-2.5 shrink-0 animate-spin" aria-hidden="true" />
      )}
      <span>{label}</span>
    </span>
  );
});
